import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClubInjuriesComponent } from './club-injuries.component';
import { ClubPlayerInjuriesComponent } from './club-player-injuries/club-player-injuries.component';
import { ClubAllInjuriesComponent } from './club-injuries-list/club-all-injuries.component';
import { ClubInjuryDetailsComponent } from '../../shared/components/club-injury-details/club-injury-details.component';


const routes: Routes = [
  {
    path: '',
    component: ClubInjuriesComponent,
    children: [
      { path: 'club-all-injuries', component: ClubAllInjuriesComponent },
      { path: 'club-player-injuries/:teamID/:playerID', component: ClubPlayerInjuriesComponent },
      { path: 'club-player-injuries/:teamID/:playerID/:injuryID', component: ClubInjuryDetailsComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClubInjuriesRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/club-injuries/club-injuries-routing.module.ts